module.exports = __webpack_public_path__ + "static/media/s20_cosmicgrey.de520792.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/samsung-galaxy/s20/s20_cosmicgrey.png
// module id = 2147
// module chunks = 0